import React, { useEffect } from "react";
import DailyActivatingOutletView from "../../../../../views/activationSales/components/simConnectivity/dailyActivatingOutletView";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { isEmptyObject, getJCJPIDs } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
// import dailyActivatingOutletData from '../data/dao.json';
// import dailyActivatingOutletCsvData from '../data/dao-csv.json';
import { simActivationCsvFilter } from "../../../../../utils/common/csvMappings/simConnectivityCsv";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";
import { triggerDashboardAudit } from "../../../../../redux/actions";

const DailyActivatingOutlet = (props) => {
  const dispatch = useDispatch();

  const { dailyActivatingOutletObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    url,
    csvEndPointUrl,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerDailyActivatingOutletAPI,
    triggerDailyActivatingOutletCsvAPI,
    moduleName,
    section,
  } = props;

  // const [downloadCsv, setDownloadCsv] = useState(false);
  // const endpointCsvData = dailyActivatingOutletCSVObj && dailyActivatingOutletCSVObj.dailyActivatingOutletCSVData;
  // const csvData = endpointCsvData && endpointCsvData[csvEndPointUrl];

  let { level, jioPointId, partnerRT, retailerId, id } =
    getJCJPIDs(filterValue);

  const headers = {
    id: id,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    partnerRoleType: partnerRT,
    section: "SIMCONNECTIVITY",
    moduleName: "ACTIVATION",
    jioPointId,
    retailerId,
    level,
  };

  useEffect(() => {
    function fetchDailyActivatingOutletData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerDailyActivatingOutletAPI(obj));
    }
    if (
      isEmptyObject(
        dailyActivatingOutletObj &&
          dailyActivatingOutletObj.dailyActivatingOutletData
      )
    ) {
      fetchDailyActivatingOutletData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.triggerDailyActivatingOutletAPI,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  function fetchDailyActivatingOutletCsvData(tab) {
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: headers,
      tab: tab,
      extraData: csvEndPointUrl,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Mdn_DAO",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerDailyActivatingOutletCsvAPI(obj, (response, params) => {
        if (response?.content?.length) {
          let csvData;
          csvData = simActivationCsvFilter(
            props.filterValue.selectedJC === ""
              ? props.filterValue.selectedPartnerRoleName
              : props.filterValue.selectedJC === "ALL"
              ? props.filterValue.selectedPartnerRoleName
              : "JP",
            props.tileName.split(" ")[0].toLowerCase(),
            response.content
          );
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  return (
    <DailyActivatingOutletView
      fetchDailyActivatingOutletCsvData={fetchDailyActivatingOutletCsvData}
      isCsvActive={props.isCsvActive}
      moduleName={moduleName}
      section={section}
    />
  );
};

DailyActivatingOutlet.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  content: PropTypes.shape({
    actualCount: PropTypes.number,
    targetCount: PropTypes.number,
    avgPerDayCount: PropTypes.number,
  }),
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerDailyActivatingOutletAPI: PropTypes.func,
  triggerDailyActivatingOutletCsvAPI: PropTypes.func,
};

export default DailyActivatingOutlet;
